export default "__VITE_ASSET__B$BeQ4ou__"